<!-- <h1 style="padding-left: 16px;"> {{ title }} </h1> -->

<!-- <main *transloco="let t">
    <h1>{{ t('welcome') }}</h1>
    <p>{{ t('description', { name: 'Lokalise'}) }}</p>
</main> -->

<!-- <h1>...{{ 'appComponent' | transloco }}...</h1> -->

<!-- <app-menu> -->
    <router-outlet />
<!-- </app-menu> -->

